/**
 * Created by wwei on 2018-03-21.
 */

import React, {Component} from 'react';

class KibanaDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            height: 600
        };
    }

    render() {
        return (
            <div className="page-container">
                <div id="container" className="col-md-12 list">
                    <h2 className="page-title">Device Dashboard</h2>
                    <div>
                        <span style={{fontSize: 14}}>Pano Dashboard:</span>
                        <iframe src="https://dashboard.pec.polycom.com/kibana6/app/kibana#/dashboard/AWDcqibtChOztZ3WmmjJ?embed=true&_g=(refreshInterval%3A('%24%24hashKey'%3A'object%3A354'%2Cdisplay%3A'5%20minutes'%2Cpause%3A!f%2Csection%3A2%2Cvalue%3A300000)%2Ctime%3A(from%3Anow-7d%2Cmode%3Aquick%2Cto%3Anow))"
                                height={this.state.height} width="100%">
                        </iframe>
                    </div>
                    <div style={{marginTop: 10}}>
                        <span style={{fontSize: 14}}>Trio Dashboard:</span>
                        <iframe src="https://dashboard.pec.polycom.com/kibana6/app/kibana#/dashboard/b8fe3e00-1673-11e8-ab73-3f067cd9b7c0?embed=true&_g=(refreshInterval%3A('%24%24hashKey'%3A'object%3A354'%2Cdisplay%3A'5%20minutes'%2Cpause%3A!f%2Csection%3A2%2Cvalue%3A300000)%2Ctime%3A(from%3Anow-7d%2Cmode%3Aquick%2Cto%3Anow))"
                                height={this.state.height} width="100%">
                        </iframe>
                    </div>
                </div>
            </div>
        );
    }
}

export default KibanaDashboard;


// WEBPACK FOOTER //
// ./src/modules/kibana/KibanaDashboard.js